import { render, staticRenderFns } from "./Deductions.vue?vue&type=template&id=38ea5263&scoped=true"
import script from "./Deductions.vue?vue&type=script&lang=js"
export * from "./Deductions.vue?vue&type=script&lang=js"
import style0 from "./Deductions.vue?vue&type=style&index=0&id=38ea5263&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ea5263",
  null
  
)

export default component.exports